import { Trans } from 'react-i18next';
import React from 'react';
import i18next from 'i18next';

import { createConfirmation } from 'actions/Confirmation';

import { addError, dismissType } from '../../actions/Error';
import { getClientCode } from 'reducers/Login';

function getConfirmationTexts() {
  // Workaround for mm because they need this message customized
  //   If other customers also need this customization in the future,
  //   we can have plugins write the texts they want to localstorage
  //   and read from localstorage here

  // But for now the texts are hardcoded so that
  //  * Almost all the code is right here, not split into multiple locations
  //  * The scope is fixed, it is clear that the workaround is only used by mm
  const isMmAccount = localStorage.getItem('workaround:isMmAccount');
  // Workaround saves clientcode-lang (e.g. "1024-en")
  // This prevents leaking the workaround to other accounts
  if (/\d+-(en|fr)/.test(isMmAccount)) {
    const [clientCode, lang] = isMmAccount.split('-');
    if (getClientCode(null) === clientCode) {
      switch (lang) {
        case 'fr':
          return {
            title: 'Mot de passe expiré',
            body: (
              <p align="center">
                Votre mot de passe a expiré ou votre organisation vous demande
                de modifier votre mot de passe. Veuillez vous rendre sur{' '}
                <a href="https://go.erply.com/" target="_blank">
                  Login (erply.com)
                </a>{' '}
                pour réinitialiser votre mot de passe.
              </p>
            ),
          };
        case 'en':
          return {
            title: 'Expired Password',
            body: (
              <p align="center">
                Your password has expired or your organization has required you
                to change your password. Please go to{' '}
                <a href="https://go.erply.com" target="_blank">
                  Erply Login App
                </a>{' '}
                to reset your password.
              </p>
            ),
          };
      }
    }
  }

  // Default behaviour
  return {
    title: i18next.t('validation:ErplyAPI.error.passwordExpired.title'),
    body: (
      <p align="center">
        <Trans i18nKey="validation:ErplyAPI.error.passwordExpired.body">
          <a href="https://login.erply.com/" target="_blank" />
        </Trans>
      </p>
    ),
  };
}

/**
 * Async actions are automatically attached a .catch handler
 * which displays ErplyAlert errors and logs errors to console
 */
export const erplyAlertOnError = (type, func) => {
  const action = async (dispatch, getState) => {
    try {
      dispatch(dismissType(type));
      return await func(dispatch, getState);
    } catch (e) {
      /**
       * 1219 stands for password expiry - needs it's own modal page
       */
      if (e.errorCode === 1219) {
        await i18next.loadNamespaces('validation');
        return new Promise(() =>
          dispatch(
            createConfirmation(
              () => {
                // do nothing
              },
              null,
              getConfirmationTexts(),
            ),
          ),
        );
      }
      console.error('Displayed banner error: ', e);
      dispatch(
        addError(e && e.message, {
          selfDismiss: 3000,
          errorType: type,
        }),
      );
      return e;
    }
  };
  action.rawAction = func;
  return action;
};
